import { render } from "./ResetPasswordDialog.vue?vue&type=template&id=c923ac3a&ts=true"
import script from "./ResetPasswordDialog.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__